import { render, staticRenderFns } from "./DynamicSearchBar.vue?vue&type=template&id=bfffe43e&"
import script from "./DynamicSearchBar.vue?vue&type=script&lang=js&"
export * from "./DynamicSearchBar.vue?vue&type=script&lang=js&"
import style0 from "./DynamicSearchBar.vue?vue&type=style&index=0&id=bfffe43e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports